import React, { useEffect, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Checkbox from "../ui/Checkbox";
import Space from "../ui/Space";
import DateInput from "../ui/DateInput";
import { arrayToObject, moveItem, showConfirm } from "../utils/Utils";
import dayjs from "dayjs";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { CUSTOMER_ADDRESS } from "../utils/Struct";
import VirtualTable from "../ui/VirtualTable";
import Divider from "../ui/Divider";
import Nav from "../ui/Nav";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";

export default function CustomerAddress(props) {

    const { controller = "", route = "", customer = {}, callback = () => { } } = props;

    const row_key = "id";
    const [results, setResults] = useState([]);
    const [selected, setSelected] = useState({});
    const [align, setAlign] = useState("auto");
    const [edit, setEdit] = useState(false)
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (edit) {
            window.bm_state.value = ROUTES.CUSTOMER.ADDRESS_EDIT;
        } else {
            window.bm_state.value = ROUTES.CUSTOMER.ADDRESS;
        }
    }, [edit]);

    const columns = [
        { key: "name", title: <>Linked addresses</>, align: "left", width: 100, grow: true },
        { key: "address_1", title: <>Address</>, align: "left", width: 100, grow: true },
        { key: "entered", title: <>Entered</>, align: "left", width: 100, grow: true },
    ]

    const getCustomerAddressTabs = () => ([
        { key: "attention", value: customer?.attention, skip: false },
        { key: "name", value: customer?.name, skip: false },
        { key: "address_1", value: customer?.address_1, skip: false },
        { key: "address_2", value: customer?.address_2, skip: false },
        { key: "city", value: customer?.city, skip: false },
        { key: "province", value: customer?.province, skip: false },
        { key: "postal_code", value: customer?.postal_code, skip: false },
        { key: "country", value: customer?.country, skip: false },
        { key: "phone", value: customer?.phone, skip: false },
        { key: "email", value: customer?.email, skip: false },
        { key: "note", value: customer?.note, skip: false },
    ]);


    const startEmptyCustomerAddress = () => {
        setSelected({});
        setTabs(getCustomerAddressTabs());
        setIndex("attention");
        setEdit(true);
    };

    const startNew = () => {
        setSelected({});
        setTabs(defaultTabs.map(item => ({ ...item })));
        setIndex("attention");
        setEdit(true);
    };

    const startEdit = () => {
        setIndex("attention"); // attention
        setEdit(true);
    };

    const stopEdit = () => {
        setEdit(false);
        blurField();
        if (results?.length) {
            setSelected(results[0]);
        } else {
            callback(false);
        }
        // switches route back to table route
    };


    const deleteAddress = () => {
        if (!selected?.id) return;



        showConfirm({
            controller: controller,
            route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}>Are you sure you want to delete this address?</div>, callback: (_key) => {
                if (_key) {
                    const deletedIndex = results.findIndex(item => item?.[row_key] === selected?.[row_key]);
                    pubCall("address.deleteAddress", { add_id: selected.id }, (_s, _r) => {
                        if (!_s) {
                            showError(_r);
                            return;
                        }

                        const nextResults = results.filter(item => item?.[row_key] !== selected?.[row_key]);

                        setResults(nextResults);

                        if (nextResults.length === 0) {
                            startEmptyCustomerAddress();
                            return;
                        }

                        const nextIndex = Math.min(deletedIndex, nextResults.length - 1);
                        setSelected(nextResults[nextIndex]);
                        setEdit(false);
                    });

                }
            }
        })


    };

    const saveAddress = () => {
        const is_new = !(selected?.[row_key]);
        const form_object = arrayToObject(tabs);
        let _api = "address.updateAddress";


        let _address = {
            ...selected,
            ...form_object,
            person_ship_to_id: customer.person_id
        };

        if (is_new) {
            _api = "address.createAddress"
            _address = {
                ...CUSTOMER_ADDRESS,
                ...form_object,
                person_ship_to_id: customer.person_id
            };
        }


        pubCall(_api, { address_info: _address, add_id: selected?.id || "" }, (_s, _r) => {
            if (!_s) {
                showError(_r);
                return;
            }

            const created = {
                ..._address,
                ..._r,
                id: _r?.id
            };

            if (!created?.id) {
                fetchAddresses();
                setEdit(false);
                return;
            }

            if (is_new) {
                setResults(prev => [...prev, created]);
            } else {
                setResults(prev =>
                    prev.map(item =>
                        item[row_key] === created[row_key]
                            ? created
                            : item
                    )
                );
            }

            setSelected(created)
            blurField();
            setEdit(false);
        });


    };


    const fetchAddresses = () => {
        setLoading(true)
        pubCall("address.readAddress", { person_id: customer?.person_id }, (_s, _r) => {
            if (_s) {
                if (_r?.length) {
                    setSelected(_r[0]);
                }
                setResults(_r)
            } else {
                showError(_r);
            }
            setLoading(false)
        })
    }

    useEffect(fetchAddresses, [])

    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }


    const defaultTabs = [
        { key: "attention", value: "", skip: false },
        { key: "name", value: "", skip: false },
        { key: "address_1", value: "", skip: false },
        { key: "address_2", value: "", skip: false },
        { key: "city", value: "", skip: false },
        { key: "province", value: "", skip: false },
        { key: "postal_code", value: "", skip: false },
        { key: "country", value: "", skip: false },
        { key: "phone", value: "", skip: false },
        { key: "email", value: "", skip: false },
        { key: "note", value: "", skip: false },

    ]


    const {
        tabs, setTabs, index, setIndex, update, updateSkip, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "attention");



    useEffect(() => {
        if (!selected?.[row_key]) return;
        setTabs([
            { key: "attention", value: selected?.attention, skip: false },
            { key: "name", value: selected?.name, skip: false },
            { key: "address_1", value: selected?.address_1, skip: false },
            { key: "address_2", value: selected?.address_2, skip: false },
            { key: "city", value: selected?.city, skip: false },
            { key: "province", value: selected?.province, skip: false },
            { key: "postal_code", value: selected?.postal_code, skip: false },
            { key: "country", value: selected?.country, skip: false },
            { key: "phone", value: selected?.phone, skip: false },
            { key: "email", value: selected?.email, skip: false },
            { key: "note", value: selected?.note, skip: false },
        ])

    }, [selected])

    useEffect(() => {
        // Empty so set to customer stuff
        if (!loading && results.length === 0 && !edit) {

            startEmptyCustomerAddress();


            setIndex("attention");
            setEdit(true);
        }
    }, [loading, results.length, edit]);


    const actions = [
        { key: KBD.ESCAPE, action: stopEdit },
        { key: KBD.PAGE_DOWN, action: saveAddress },
        { key: KBD.ARROW_DOWN, action: () => next() },
        { key: KBD.ARROW_UP, action: () => prev() },
    ];

    const nav = [
        { key: KBD.ESCAPE, action: () => callback(false) },
        { key: KBD.ENTER, action: () => callback(selected) },
        { key: KBD.PAGE_DOWN, action: () => callback(selected) },
        { key: KBD.D, text: "Delete", action: () => deleteAddress() },
        { key: KBD.E, text: "Edit", action: startEdit },
        { key: KBD.N, text: "New", action: startNew },
    ];



    useEffect(() => {


        if (edit && window.bm_state.value === ROUTES.CUSTOMER.ADDRESS_EDIT) {
            refs?.current?.[index]?.focus?.();
        }


        const cleanup = listen(controller, (edit) ? ROUTES.CUSTOMER.ADDRESS_EDIT : route, (edit) ? actions : nav, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]);
        return cleanup;

    }, [tabs, index, edit, results, selected])

    const processAndCallback = (_arr = tabs) => {
        let _ret = arrayToObject(_arr);

        console.log(_ret);
        return;
        // _ret.cancel_date = (_ret.cancel_date) ? dayjs(_ret.cancel_date).valueOf() : 0;
        // _ret.hold_till = (_ret.hold_till) ? dayjs(_ret.hold_till).valueOf() : 0;
        callback(_ret);
    }



    const nextRow = (_rows = 1) => {
        moveItem({ data: results, selected, setSelected, row_key: row_key, step: _rows, setAlign, alignOnMove: false })
    };
    const prevRow = (_rows = 1) => {
        moveItem({ data: results, selected, setSelected, row_key: row_key, step: -_rows, setAlign, alignOnMove: true })
    };




    return (
        <div style={{ "width": "400px" }}>
            <div className="shim" /><div className="shim" />
            <Space>
                <Label width={80}>Attn</Label>
                <Input width={300} {...editProps("attention")} onEnter={() => next()} edit={edit} placeholder="Attn..." />
            </Space>
            <div className="shim" />
            <Space>
                <Label width={80}>Name</Label>
                <Input width={300} {...editProps("name")} onEnter={() => next()} edit={edit} placeholder="Name..." />
            </Space>

            <div className="shim" />
            <Space>
                <Label width={80}>Address 1</Label>
                <Input width={300} {...editProps("address_1")} onEnter={() => next()} edit={edit} placeholder="Address..." />
            </Space>

            <div className="shim" />
            <Space>
                <Label width={80}>Address 2</Label>
                <Input width={300} {...editProps("address_2")} onEnter={() => next()} edit={edit} placeholder="Address..." />
            </Space>

            <div className="shim" />

            <Space>
                <Label width={80}>City</Label>
                <Input width={200} {...editProps("city")} onEnter={() => next()} edit={edit} placeholder="City..." />
                <Label >Prov</Label>
                <Input width={50} {...editProps("province")} onEnter={() => next()} edit={edit} placeholder="Prov..." />
            </Space>

            <div className="shim" />

            <Space>
                <Label width={80}>Postal Code</Label>
                <Input width={129} {...editProps("postal_code")} onEnter={() => next()} edit={edit} placeholder="Postal code..." />
                <Label >Country</Label>
                <Input width={100} {...editProps("country")} onEnter={() => next()} edit={edit} placeholder="Country..." />
            </Space>

            <div className="shim" />
            <Space>
                <Label width={80}>Phone</Label>
                <Input width={300} {...editProps("phone")} onEnter={() => next()} edit={edit} placeholder="Phone..." />
            </Space>

            <div className="shim" />
            <Space>
                <Label width={80}>Email</Label>
                <Input width={300} {...editProps("email")} onEnter={() => next()} edit={edit} placeholder="Address..." />
            </Space>

            <div className="shim" />
            <Space>
                <Label width={80}>Note</Label>
                <Input width={300} {...editProps("note")} onEnter={() => next()} edit={edit} placeholder="Note..." />
            </Space>

            <div className="shim" /><div className="shim" />
            <Divider />
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}

                // headerClass="danger"
                onRowDoubleClick={(item) => callback(item)}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                next={nextRow}
                prev={prevRow}
                align={align}
                row_key={row_key}
                current={selected}
                data={results}
                columns={columns}
                // width={960}
                loading={loading}
                height={180}
                offset={0}
                route={route}
            />
            <div className="shim" />
            <div style={{ "margin": "0px -10px" }}><Divider /></div>
            {(edit) ? <Status type="active"><InfoIcon />[PgDn] to save, [Esc] to return</Status> : <Nav nav={nav} />}

        </div>
    )
}